import apiClient from "../apiClient";

const login = (credential) => apiClient.post("/admin/signin", credential);

const forgotPassword = (email) =>
  apiClient.post("/admin/forgot-password", { email });

const resetPassword = (data) => apiClient.post("/admin/reset-password", data);

const generateNewOtp = (data) =>
  apiClient.post("/admin/generate-new-otp", data);

const sendOtp = (data) => apiClient.post("/admin/generate-new-otp", data);

const verifyOtp = (data) => apiClient.post("/admin/verify-otp", data);

export default {
  login,
  forgotPassword,
  resetPassword,
  generateNewOtp,
  sendOtp,
  verifyOtp,
};
